module.exports = __webpack_public_path__ + "static/media/26.eab95b9e.jpg";